<script setup lang="ts">
import { useTranslate } from '@tolgee/vue'

const { t } = useTranslate()

interface MenuItem {
  title: string
  link: string
}

interface Props {
  menuItems: MenuItem[]
}

defineProps<Props>()
</script>

<template>
  <ul class="public-footer-menu-item-links">
    <li v-for="(item, index) in menuItems" :key="index">
      <a target="_blank" :href="item.link" rel="nofollow">
        {{ t(item.title) }}
      </a>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.public-footer-menu-item {
  @include media('md-and-up') {
    width: 150px;
  }
}

.public-footer-menu-item-links a {
  font-size: 18px;
  line-height: 24px;
  color: var(--ui-black);

  .dark & {
    color: var(--lightest);
  }

  .community-page & {
    color: var(--lightest);
  }
}

.public-footer-menu-item-links {
  list-style-type: none;

  a {
    display: inline-block;
    text-decoration: none;
    margin-top: 12px;

    &:hover {
      color: var(--ui-emerald-green);
    }
  }
}
</style>
